import ArchiveBackendsPage from 'archive/ArchiveBackendsPage';
import ArchivePage from 'archive/ArchivePage';
import ArchiveConfigurationPage from 'archive/ArchiveConfigurationPage';
import ArchiveBackendConfigurationPage from 'archive/ArchiveBackendConfigurationPage';
import ArchiveRetentionStrategySummary from 'archive/components/ArchiveRetentionStrategySummary';
import ArchiveRetentionStrategyConfiguration from 'archive/components/ArchiveRetentionStrategyConfiguration';
import ArchiveRoutes from 'archive/Routes';

export default {
  routes: [
    { path: ArchiveRoutes.unqualified.LIST, component: ArchivePage },
    { path: ArchiveRoutes.unqualified.CONFIGURATION, component: ArchiveConfigurationPage },
    { path: ArchiveRoutes.unqualified.BACKENDS.LIST, component: ArchiveBackendsPage },
    { path: ArchiveRoutes.unqualified.BACKENDS.CREATE, component: ArchiveBackendConfigurationPage },
    { path: ArchiveRoutes.unqualified.BACKENDS.show(), component: ArchiveBackendConfigurationPage },
  ],
  indexRetentionConfig: [
    {
      type: 'org.graylog.plugins.archive.indexer.retention.strategies.ArchiveRetentionStrategy',
      displayName: 'Archive Index',
      configComponent: ArchiveRetentionStrategyConfiguration,
      summaryComponent: ArchiveRetentionStrategySummary,
    },
  ],
};
